import { JSX } from 'react';
import { twMerge } from 'tailwind-merge';

import { Text } from '@videoblocks/design-system';

import { usePlayAudio } from '../../_hooks/usePlayAudio';
import { PlayButton } from '../PlayButton';

export interface TextInputPlayButtonProps {
    preview_url: string;
    voiceId: string;
    playingVoiceId: string | null;
    onPlayHandler: (voiceId: string) => void;
    voiceName: string;
    isContributorVoice: boolean;
    className?: string;
}

export const TextInputPlayButton = ({
    preview_url,
    voiceId,
    playingVoiceId,
    onPlayHandler,
    voiceName,
    isContributorVoice,
    className = '',
}: TextInputPlayButtonProps): JSX.Element => {
    const formattedVoiceName = isContributorVoice ? `${voiceName} - Artist Voice` : `${voiceName} - Core Voice`;
    const href = isContributorVoice ? '#contributor-voice-list' : '#voice-list';

    const { isPlaying, handlePlayPause } = usePlayAudio(preview_url, voiceId, playingVoiceId, onPlayHandler);

    return (
        <div
            className={twMerge(
                'w-full md:w-auto flex justify-center items-center gap-x-3 rounded-capsule border border-neutral-dark-300 px-3 py-2 bg-neutral-dark-200',
                className,
            )}
        >
            <PlayButton
                previewUrl={preview_url}
                isPlaying={isPlaying}
                handlePlayPause={handlePlayPause}
                size="sm"
                className="bg-white hover:bg-yellow-500"
            />
            <Text asChild fontWeight="regular">
                <span>{formattedVoiceName}</span>
            </Text>
            <Text asChild fontSize="sm" className="underline">
                <a
                    href={href}
                    onClick={(e) => {
                        e.preventDefault();
                        const target = document.querySelector(href);
                        if (target) {
                            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        }
                    }}
                >
                    Edit
                </a>
            </Text>
        </div>
    );
};
